<form #form="ngForm">
<div class="border-outline">
  <h3 class="outline-border-header" anessaTranslation="PROJECT.FEEDSTOCK.TYPE.TITLE"></h3>
  <div class="flex-container flow-column">
    <div class="flex-box tour-name">
      <div
        (mouseenter)="showClearName = true"
        (mouseleave)="showClearName = false"
        class="edit-inline-row form-field-container">
        <mat-form-field>
          <mat-label>{{'PROJECT.FEEDSTOCK.TYPE.NAME' | anessaTranslation: trigger}}</mat-label>
          <input
            id="feedstock-basic-info-name_input"
            required
            [(ngModel)]="feedstock.name"
            type="text"
            name="name"
            id="name-input"
            matInput
            label="name"
            (ngModelChange)="validateName(); changesMadeNotifier.emit(); formValidityUpdated()"
          >
          <mat-error *ngIf="form.controls['name'] && form.controls['name'].hasError('incorrect-input')">
            {{'PROJECT.COMMON.DOT_ERROR' | anessaTranslation: trigger}}
          </mat-error>
        </mat-form-field>
        <p
          *ngIf="feedstock.name && showClearName"
          class="form-field-clear"
          (click)="clearInput('name')">{{'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger}}</p>
      </div>
    </div>
    <div class="flex-box">
      <div
        (mouseenter)="showClearDesc = true"
        (mouseleave)="showClearDesc = false"
        class="edit-inline-row form-field-container">
        <mat-form-field floatLabel="always">
          <mat-label>{{'PROJECT.FEEDSTOCK.TYPE.DESC' | anessaTranslation: trigger}}</mat-label>
          <input
            id="feedstock-basic-info-description_input"
            [(ngModel)]="feedstock.description"
            type="text"
            name="description"
            id="description-input"
            matInput
            (ngModelChange)="changesMadeNotifier.emit()"
          >
        </mat-form-field>
        <p
          *ngIf="feedstock.description && showClearDesc"
          class="form-field-clear"
          (click)="clearInput('description')">{{'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger}}</p>
      </div>
    </div>
    <div class="flex-box border-shadow  tour-search">
      <h3 class="no-default-margin dropdown-header info-style">
        {{(anessaDatabaseRequired ? 'PROJECT.FEEDSTOCK.TYPE.USE_DB_REQUIRED' : 'PROJECT.FEEDSTOCK.TYPE.USE_DB') | anessaTranslation: trigger}}
        <mat-icon
          *ngIf="anessaDatabaseRequired"
          matTooltip="{{'PROJECT.FEEDSTOCK.TYPE.USE_DB_HELP' | anessaTranslation: trigger}}">
          help
        </mat-icon>
        <mat-icon
          [matTooltip]="getInfoText()">
          info
        </mat-icon>
      </h3>
      <app-feedstock-dropdowns
        [projectInputDisplay]="projectInputDisplay"
        [feedstock]="feedstock"
        (changesMadeNotifier)="changesMadeNotifier.emit()"
        [feedstockChangedNotifier]="feedstockUpdatedNotifier"
      ></app-feedstock-dropdowns>
    </div>
  </div>
</div>
<div class="border-outline">
  <h3 class="outline-border-header" anessaTranslation="PROJECT.FEEDSTOCK.QUANTITY.TITLE"></h3>
  <app-feedstock-quantities
    [feedstock]="feedstock"
    (changesMadeNotifier)="changesMadeNotifier.emit()"
    (formIsValid)="quantitiesValid=$event; formValidityUpdated()"
  ></app-feedstock-quantities>
</div>
<div *ngIf="projectInputDisplay" class="flex-container">
  <h3 class="characteristics-toggle-title" anessaTranslation="PROJECT.FEEDSTOCK.CHARACTERISTICS.TOGGLE_TITLE"></h3>
  <div class="vertical-center">
    <mat-slide-toggle
      [(ngModel)]="feedstock.characteristics.characteristicsEnabled"
      [ngModelOptions]="{standalone: true}"
      (ngModelChange)="changesMadeNotifier.emit()">
      {{'PROJECT.COMMON.ENABLE_TOGGLE' | anessaTranslation: trigger}}
      {{'PROJECT.COMMON.OPTIONAL' | anessaTranslation: trigger}}
    </mat-slide-toggle>
  </div>
</div>
<div *ngIf="!projectInputDisplay || feedstock.characteristics.characteristicsEnabled" class="border-outline">
  <h3 class="outline-border-header" anessaTranslation="PROJECT.FEEDSTOCK.CHARACTERISTICS.TITLE"></h3>
  <app-feedstock-characteristics
    [projectInputDisplay]="projectInputDisplay"
    [feedstock]="feedstock"
    (changesMadeNotifier)="changesMadeNotifier.emit()"
    (formIsValid)="characteristicsValid=$event; formValidityUpdated()"
  ></app-feedstock-characteristics>
</div>
</form>
